
import React from "react";
import SiteDetailPage from "@/components/sites/SiteDetailPage";

const ProfitRecyclage = () => {
  const services = [
    "Location de bennes",
    "Collecte de déchets",
    "Recyclage industriel",
    "Traitement de métaux"
  ];

  return (
    <SiteDetailPage
      title="Profit Recyclage - Location de Bennes Beauchamp (95250)"
      description="Profit Recyclage à Beauchamp - Solutions complètes de gestion des déchets et location de bennes pour professionnels dans le Val-d'Oise. Devis gratuit."
      proximityInfo="Centre de recyclage professionnel desservant Beauchamp et les communes environnantes du Val-d'Oise pour tous vos besoins en gestion de déchets."
      address="8/10 Rue Denis Papin"
      postalCode="95250"
      city="Beauchamp"
      phone="01 34 64 05 31"
      email="contactgfe@groupefabre.com"
      website="https://bennesprofit.com/"
      services={services}
      coordinates={{ lat: 49.0058, lng: 2.2025 }}
      isMiniSite={true}
    />
  );
};

export default ProfitRecyclage;
